import { t } from 'i18next';
import React from 'react';

import Button, { ButtonProps } from '../././Button';

import { ErrorComponentProps } from './helpers';

const ErrorButtonWithFeedback = (props: ErrorComponentProps & ButtonProps) => {
  const { children, onReload } = props;

  if (!onReload) {
    return null;
  }

  return (
    <Button icon="refresh" onClick={onReload} {...props}>
      {children ?? t('errors.retry')}
    </Button>
  );
};

export default ErrorButtonWithFeedback;
